const BaseView = require('../lib/model-binder');
const _ = require('underscore');
const $ = require('jquery');
const dateFormat = require('dateformat');
const JumpTo = require('./jump-to');
const HelpScreen = require('./help-screen');
const SettingsScreen = require('./settings-screen');
const SpellcheckerScreen = require('./spellchecker-screen');
const appManager = require('../app-manager');
const dispatcher = require('../dispatcher');
const template = require('../templates/control-menu.jade');
const spellchecker = require('../helpers/spellchecker');
const parent = BaseView.prototype;
// const toastr = require('toastr');
// const toastr = require('../helpers/toastr-config');

module.exports = BaseView.extend({
	autoRender: true,
	model: null,
	jumpToView: null,
	helpScreenView: null,

	events: {
		'click .edit': 'editSubtitle',
		'click .add': 'addSubtitle',
		'click .delete': 'deleteSubtitle',
		'click .split': 'splitSubtitle',
		'click .merge': 'mergeSubtitle',
		'click .undo': 'undoChanges',
		'click .redo': 'redoChanges',
		'click .italic': 'italicFont',
		'click .search-up': 'searchUp',
		'click .search-down': 'searchDown',
		'keydown .search': 'onSearchKeyDown',
		'click .jump-to': 'jumpTo', 
		'click .spell-check': 'activateSpellCheck',
		'click .sync': 'sync',
		'click .black-bg': 'blackBg',
		'click .next-change': 'changeNavigate',
		'click .prev-change': 'changeNavigate',
		'click .next-unclear': 'unclear',
		'click .prev-unclear': 'unclear',
		'click .help': 'helpMenu',
		'click .settings': 'settingsMenu',
		'change #language': 'updateLanguage',
		'click .before': 'insertBefore',
		'click .after': 'insertAfter',
		'click .lastSync': 'onLastSyncClick',
		'mouseenter .lastSync': 'onLastSyncMouseEnter',
		'mouseleave .lastSync': 'onLastSyncMouseLeave',
	},

	initialize: function (options) {
		_.extend(this, options);
	
		_.bindAll(this, 'editSubtitle', 'jumpTo', 'activateSpellCheck', 'searchUp', 'searchDown', 'onSearchKeyDown', 'search', 'changeNavigate', 'updateLastSync', 'customView');
	
		this.initEventListeners();
	
		parent.initialize.apply(this, arguments);
	
		if (this.autoRender) this.render();
	
		// Set toastr options
		// toastr.options = {
		// 	"closeButton": false,
		// 	"debug": false,
		// 	"newestOnTop": false,
		// 	"progressBar": false,
		// 	"positionClass": "toast-bottom-center", // Change this to your desired position
		// 	"preventDuplicates": false,
		// 	"onclick": null,
		// 	"showDuration": "5000",
		// 	"hideDuration": "1000",
		// 	"timeOut": "5000",
		// 	"extendedTimeOut": "1000",
		// 	"showEasing": "swing",
		// 	"hideEasing": "linear",
		// 	"showMethod": "fadeIn",
		// 	"hideMethod": "fadeOut"
		// };
	
		//console.log('Toastr is ready to use in control menu');
	},
	

	initEventListeners: function () {
		this.listenTo(dispatcher, dispatcher.events.JUMP_TO, this.jumpTo);

		this.listenTo(dispatcher, dispatcher.events.DISABLE_KEYBOARD_CONTROLS, _.bind(function () {
			this.$('input, button, select').prop('disabled', true);
			this.$('.insert-wrapper').addClass('hidden');
		}, this));

		this.listenTo(dispatcher, dispatcher.events.ENABLE_KEYBOARD_CONTROLS, _.bind(function () {
			this.$('input, button, select').prop('disabled', false);
		}, this));

		this.listenTo(dispatcher, dispatcher.events.UPDATE_LAST_SYNC_TIME, this.updateLastSync);

		this.listenTo(this.model, 'change:availableLanguages', this.parseLanguageSelection);

		this.listenTo(dispatcher, dispatcher.events.APP_MODEL_INITIALIZED, this.customView);

	},

	render: function () {
		this.setElement(template());

		this.modelBinder.bind(this.model, this.$el, {
			captionLastUpdate: {
				selector: '.last-sync'
			}
		});

		return this;
	},

	customView: function() {
		if (!spellchecker.isSuportted()) {
			this.$("button.spell-check").remove();
		}
	},

	UpdateQueryString: function (key, value) {
		key = encodeURI(key);
		value = encodeURI(value);

		var kvp = document.location.search.substr(1).split('&');

		var i = kvp.length;
		var x;
		while (i--) {
			x = kvp[i].split('=');

			if (x[0] == key) {
				x[1] = value;
				kvp[i] = x.join('=');
				break;
			}
		}

		if (i < 0) {
			kvp[kvp.length] = [key, value].join('=');
		}
		//this will reload the page, it's likely better to store this until finished
		document.location.search = kvp.join('&');

	},

	parseLanguageSelection: function () {

		var languages = this.model.get('availableLanguages');
		var currentLanguageId = this.model.get('currentLanguageId');

		var options;

		_.each(languages, function (language) {
			options += '<option value="' + language['key'] + '">' + language['value'] + '</option>';
		});

		this.$('#language').html(options);

		if (!localStorage.hasOwnProperty('capNsub-language')) {
			localStorage.setItem('capNsub-language', _.first(languages)['key']);
		} else {
			var current = localStorage.getItem('capNsub-language');
			this.$('#language').val(current);

		}
		var selectedLanguage = $('#language option:selected').text();
	
		if (selectedLanguage.toLocaleLowerCase() == "hebrew" ||
			selectedLanguage.toLocaleLowerCase() == "super-he" ||
			selectedLanguage.toLocaleLowerCase() == "super-heb" ||
			selectedLanguage.toLocaleLowerCase() == "supers-he" ||
			selectedLanguage.toLocaleLowerCase() == "supers-heb" ||
			selectedLanguage.toLocaleLowerCase() == "arabic" ||
			selectedLanguage.toLocaleLowerCase() == "super-ar" ||
			selectedLanguage.toLocaleLowerCase() == "super-arb" ||
			selectedLanguage.toLocaleLowerCase() == "supers-ar" ||
			selectedLanguage.toLocaleLowerCase() == "supers-arb" ||
			selectedLanguage.toLocaleLowerCase() == "Heb-Arb" ||
			selectedLanguage.toLocaleLowerCase() == "Hebrew-VTT" ||
			selectedLanguage.toLocaleLowerCase() == "Other-AR" ||
			selectedLanguage.toLocaleLowerCase() == "Other-HE" ||
			selectedLanguage.toLocaleLowerCase() == "Hebrew-English" ||
			selectedLanguage.toLocaleLowerCase() == "Yiddish" ||
			selectedLanguage.toLocaleLowerCase() == "Heb-Arb-Supers"
		)
		{
			$("input[name=search]").css("text-align","right");
		}
		else $("input[name=search]").css("text-align","left");
	},

	editSubtitle: function () {
	
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.EDIT_SUBTITLE);
	},

	addSubtitle: function () {
		var selectedRow = $('.row.subtitle.selected');
	
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
	
		if (selectedRow.index() == 0) {
			this.$('.insert-wrapper').toggleClass('hidden');
		} else {
			dispatcher.emit(dispatcher.events.ADD_SUBTITLE);
		}
	},
	

	deleteSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.DELETE_SUBTITLE);
	},

	splitSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.SPLIT_SUBTITLE);
	},

	mergeSubtitle: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.MERGE_SUBTITLE);
	},

	undoChanges: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.UNDO_CHANGES);
	},

	redoChanges: function () {
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.REDO_CHANGES);
	},

	italicFont: function () {
		dispatcher.emit(dispatcher.events.ITALIC);
	},

	searchDown: function() {
		this.search(1)
	},

	searchUp: function() {
		this.search(-1)
	},
	onSearchKeyDown: function(e) {
		if (e.which !=13) {
			return;
		}
		this.searchDown();
	},
	search: function (dir) {
		var $input = this.$('[name="search"]');
		var val = $input.val().trim();

		if (val.length == 0) {
			toastr.info("Search box is empty.");
			$input.focus();
			return;
		}

		dispatcher.emit(dispatcher.events.SEARCH, val, dir);
	},

	jumpTo: function () {
		if (this.jumpToView) this.jumpToView.remove();

		this.jumpToView = new JumpTo({
			collection: this.model.get('subtitle')
		});

		this.jumpToView.$el.appendTo(appManager.main.layout.find('#app'));
		appManager.main.layout.find('.go-to-subtitle').focus();
	},

	activateSpellCheck: async function() {
		let collection = this.model.get('subtitle');

		if (this.spellcheckerScreenView) this.spellcheckerScreenView.remove();

		this.spellcheckerScreenView = new SpellcheckerScreen({collection});

		this.spellcheckerScreenView.$el.appendTo(appManager.main.layout.find('#app'));
	},

	sync: function (e) {
		var $el = $(e.currentTarget);

		var off = 'Synchronize Off';
		var on = 'Synchronize On';

		$el.toggleClass('active');

		$el.attr('title') == off ? $el.attr('title', on) : $el.attr('title', off);

		dispatcher.emit(dispatcher.events.SYNC);
	},

	blackBg: function (e) {
		
		var blackBg = localStorage.getItem("blackBg");
		$(e.currentTarget).toggleClass('active');

		if(blackBg == "true")
			localStorage.setItem("blackBg",false);
		else localStorage.setItem("blackBg",true);

		dispatcher.emit(dispatcher.events.BLACK_BG);
	},

	changeNavigate: function (e) {
		var $this = $(e.currentTarget);
		var dir = $this.hasClass('prev-change') ? -1 : 1;

		dispatcher.emit(dispatcher.events.NAVIGATE_CHANGE, dir);
	},

	unclear: function (e) {
		var $this = $(e.currentTarget);
		var dir = $this.hasClass('prev-unclear') ? -1 : 1;

		dispatcher.emit(dispatcher.events.SEARCH, "???", dir);
		dispatcher.emit(dispatcher.events.SEARCH, "؟؟؟", dir);
	},

	helpMenu: function () {
		if (this.helpScreenView) this.helpScreenView.remove();

		this.helpScreenView = new HelpScreen();

		this.helpScreenView.$el.appendTo(appManager.main.layout.find('#app'));
	},

	settingsMenu: function () {
		if (this.settingsScreenView) this.settingsScreenView.remove();

		this.settingsScreenView = new SettingsScreen();

		this.settingsScreenView.$el.appendTo(appManager.main.layout.find('#app'));
	},

	updateLanguage: function (e) {
		var $this = $(e.currentTarget);
		this.model.set('currentLanguageId', $this.val());
		localStorage.setItem('capNsub-language', $this.val());
		this.UpdateQueryString("TranslationId", $this.val());
	},

	updateLastSync: function () {
		var now = new Date();
		this.model.set('captionLastUpdate', dateFormat(now, "d/mm/yy HH:MM:ss"));
	},

	insertBefore: function () {
		this.$('.insert-wrapper').addClass('hidden');
		dispatcher.emit(dispatcher.events.ADD_SUBTITLE, true);
	},

	insertAfter: function () {
		this.$('.insert-wrapper').addClass('hidden');
		dispatcher.emit(dispatcher.events.ADD_SUBTITLE);
	},
	
	onLastSyncClick: function () {
		$(".control-menu .mr5").css("opacity","1");
	},

	onLastSyncMouseEnter: function () {
		$(".control-menu .mr5").css("opacity","1");
	},

	onLastSyncMouseLeave: function () {
		$(".control-menu .mr5").css("opacity","0");
	}
});


// WEBPACK FOOTER //
// ./app/views/control-menu.js